module.exports = __webpack_public_path__ + "static/img/福華墾丁.1137235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/福華墾丁.png?20181011
// module id = 0zL7
// module chunks = 1